import styled from 'styled-components';

export const ResponsiveGridContainer = styled.div`
    width: 100vw;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    // display: grid;
    // grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    // grid-gap: 30px;
`;

export const ItemContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const BdIcon = styled.img`
    width: ${props => (props.size ? `${props.size}px` : null)};
    height: ${props => (props.size ? `${props.size}px` : null)};
    margin: 8px;
`;

export const TextContainer = styled.div`
    width: ${props => (props.size ? `${props.size}px` : null)};
    display: flex;
    justify-content: center;
`;



// WEBPACK FOOTER //
// ./src/UI/Containers/GymTv/WorkoutProgramme/Content/style.js